import loadable from '@/utils/loadable';
import Loader from '../ui/loader';

export const NotFoundPage = loadable(() => import('@/pages/NotFoundPage'), {
  fallback: <Loader />,
});

export const Login = loadable(() => import('@/pages/auth/LoginPage'), {
  fallback: <Loader />,
});

export const DashboardPage = loadable(() => import('@/pages/dashboard/DashboardPage'), {
  fallback: <Loader />,
});
export const OnboardingPage = loadable(() => import('@/pages/onboarding/OnboardingPage'), {
  fallback: <Loader />,
});
export const AccountDetails = loadable(
  () => import('@/pages/Downline/AccountDetails/AccountDetails'),
  {
    fallback: <Loader />,
  }
);
export const AccountSummary = loadable(
  () => import('@/pages/Downline/AccountDetails/AccountSummary'),
  {
    fallback: <Loader />,
  }
);
export const TransactionHistory = loadable(
  () => import('@/pages/Downline/AccountDetails/TransactionHistory'),
  {
    fallback: <Loader />,
  }
);
export const UserAccountStatement = loadable(
  () => import('@/pages/Downline/AccountDetails/UserAccountStatement'),
  {
    fallback: <Loader />,
  }
);

export const UserBetHistory = loadable(
  () => import('@/pages/Downline/AccountDetails/UserBetHistory'),
  {
    fallback: <Loader />,
  }
);
export const UserBettingPL = loadable(
  () => import('@/pages/Downline/AccountDetails/UserBettingPL'),
  {
    fallback: <Loader />,
  }
);

export const CasinoPl = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/CasinoPl'),
  {
    fallback: <Loader />,
  }
);
export const SportsPL = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/SportsPL'),
  {
    fallback: <Loader />,
  }
);
export const UserSportsBets = loadable(
  () => import('@/pages/Downline/AccountDetails/BetHistoryDetails/UserSportsBets'),
  {
    fallback: <Loader />,
  }
);
export const UserCasinoBets = loadable(
  () => import('@/pages/Downline/AccountDetails/BetHistoryDetails/UserCasinoBets'),
  {
    fallback: <Loader />,
  }
);

export const ActivityLog = loadable(() => import('@/pages/Downline/AccountDetails/ActivityLog'), {
  fallback: <Loader />,
});
export const Bankers = loadable(() => import('@/pages/Banker-management/Bankers'), {
  fallback: <Loader />,
});
export const AllDownlineListing = loadable(() => import('@/pages/Downline/AllDownlineListing'), {
  fallback: <Loader />,
});
export const DWRequest = loadable(() => import('@/pages/Banker-management/DWRequest'), {
  fallback: <Loader />,
});
export const ManageAccount = loadable(() => import('@/pages/Banker-management/ManageAccount'), {
  fallback: <Loader />,
});
export const ContentManagement = loadable(() => import('@/pages/ContentManagement/'), {
  fallback: <Loader />,
});
export const BannerManagement = loadable(
  () => import('@/pages/ContentManagement/BannerManagement'),
  {
    fallback: <Loader />,
  }
);
export const SupportContactManagement = loadable(
  () => import('@/pages/ContentManagement/SupportContactManagement'),
  {
    fallback: <Loader />,
  }
);
export const NotificationManagement = loadable(
  () => import('@/pages/ContentManagement/NotificationManagement'),
  {
    fallback: <Loader />,
  }
);
export const SubUsers = loadable(() => import('@/pages/Downline/SubUsers'), {
  fallback: <Loader />,
});
export const CasinoControl = loadable(() => import('@/pages/CasinoManagement/CasinoControl'), {
  fallback: <Loader />,
});
export const CategoryControl = loadable(() => import('@/pages/CasinoManagement/CategoryControl'), {
  fallback: <Loader />,
});
export const ProviderControl = loadable(() => import('@/pages/CasinoManagement/ProviderControl'), {
  fallback: <Loader />,
});
export const GameControl = loadable(() => import('@/pages/CasinoManagement/GameControl'), {
  fallback: <Loader />,
});
export const FilteredGames = loadable(() => import('@/pages/CasinoManagement/FilteredGames'), {
  fallback: <Loader />,
});

export const BankerDashboard = loadable(() => import('@/pages/dashboard/BankerDashboard'), {
  fallback: <Loader />,
});

// Banker Management
export const AccountStatement = loadable(
  () => import('@/pages/Banker-management/AccountStatement'),
  { fallback: <Loader /> }
);

export const BankerDetail = loadable(() => import('@/pages/Banker-management/BankerDetail'), {
  fallback: <Loader />,
});

// Settings
export const Setting = loadable(() => import('@/pages/settings/ChnagePassword'), {
  fallback: <Loader />,
});

// Affiliate Management
export const DashBoard = loadable(() => import('@/pages/AffiliateManagement/DashBoard'), {
  fallback: <Loader />,
});

export const AffiliateReq = loadable(() => import('@/pages/AffiliateManagement/AffiliateReq'), {
  fallback: <Loader />,
});

export const ComissionReport = loadable(
  () => import('@/pages/AffiliateManagement/ComissionReport'),
  { fallback: <Loader /> }
);

export const AffiliateActiveUserOfWeek = loadable(
  () => import('@/pages/AffiliateManagement/ComissionReport/AffiliateActiveUserOfWeek'),
  { fallback: <Loader /> }
);

export const AffiliateListing = loadable(
  () => import('@/pages/AffiliateManagement/AffiliateListing'),
  { fallback: <Loader /> }
);

export const SubUsersListing = loadable(
  () => import('@/pages/AffiliateManagement/AffiliateListing/SubUsersListing'),
  { fallback: <Loader /> }
);

// Downline / Casino Panel
export const CasinoDetail = loadable(() => import('@/pages/Downline/AccountDetails/CasinoPanel'), {
  fallback: <Loader />,
});

// Event Management
export const EventManagement = loadable(() => import('@/pages/EventManagement/EventManagement'), {
  fallback: <Loader />,
});

export const BetSetting = loadable(() => import('@/pages/EventManagement/BetSetting'), {
  fallback: <Loader />,
});

// Common component
export const TransactionCode = loadable(() => import('@/components/common/TransactionCode'), {
  fallback: <Loader />,
});

// Risk Management
export const Risk = loadable(() => import('@/pages/RiskManagement/Risk'), { fallback: <Loader /> });
export const RiskDetailsPage = loadable(() => import('@/pages/RiskManagement//RiskDetailsPage'), {
  fallback: <Loader />,
});

// Reports
export const BetList = loadable(() => import('@/pages/Reports/BetList'), { fallback: <Loader /> });

export const PlDownline = loadable(() => import('@/pages/Reports/PlDownline'), {
  fallback: <Loader />,
});

export const PlByPlayer = loadable(() => import('@/pages/Reports/PlByPlayer'), {
  fallback: <Loader />,
});

export const PlByEvent = loadable(() => import('@/pages/Reports/PlByEvent'), {
  fallback: <Loader />,
});

export const CasinoBetList = loadable(() => import('@/pages/Reports/CasinoBetList'), {
  fallback: <Loader />,
});

export const CasinoPlByPlayer = loadable(() => import('@/pages/Reports/CasinoPlbyPlayers'), {
  fallback: <Loader />,
});

export const CasinoPlByDownline = loadable(() => import('@/pages/Reports/CasinoPlByDownline'), {
  fallback: <Loader />,
});
export const ActivityLogs = loadable(() => import('@/pages/ActivityLogs'), {
  fallback: <Loader />,
});

export const InactiveMemerList = loadable(() => import('@/pages/Reports/InactiveMemeber'), {
  fallback: <Loader />,
});

export const Export = loadable(() => import('@/pages/ExportHistory/Export'), {
  fallback: <Loader />,
});

export const BussinessReports = loadable(
  () => import('@/pages/Reports/BusinessReport/BussinessReports'),
  {
    fallback: <Loader />,
  }
);

export const RoleWiseAccountStatement = loadable(() => import('@/pages/RoleWiseAccountStatement'), {
  fallback: <Loader />,
});

export const RolesAndPrivileges = loadable(() => import('@/pages/RolesAndPrivileges'), {
  fallback: <Loader />,
});

export const Roles = loadable(() => import('@/pages/RolesAndPrivileges/Roles'), {
  fallback: <Loader />,
});

export const AccessControl = loadable(() => import('@/pages/RolesAndPrivileges/AccessControl'), {
  fallback: <Loader />,
});

export const CreateRoles = loadable(
  () => import('@/pages/RolesAndPrivileges/components/CreateRoles'),
  {
    fallback: <Loader />,
  }
);
// crypto conversion rate

export const CryptoConversion = loadable(() => import('@/pages/CryptoConversion'), {
  fallback: <Loader />,
});

export const PolicyManagement = loadable(() => import('@/pages/Bonus/PolicyManagement'), {
  fallback: <Loader />,
});

export const BonusStatement = loadable(() => import('@/pages/Bonus/Statement'), {
  fallback: <Loader />,
});
//route  for settlement
export const Settlement = loadable(() => import('@/pages/Settlement'), {
  fallback: <Loader />,
});

// add promotion
export const AddPromotion = loadable(() => import('@/pages/AddPromotion'), {
  fallback: <Loader />,
});
